import React from 'react';
import { Button, Typography, TextField, MenuItem } from '@material-ui/core';
import { Formik } from 'formik';
import { useRootStore } from '../../../stores/BridgeProvider';
import {
  FlexDiv,
  StandardBox,
  StyledForm,
  FormRow,
  RowItem,
} from '../../styles/styles';
import SimpleSelect from '../../util/SimpleSelect';
import { safeFalsy, safeEval } from '../../util/UtilFunctions';
import AccountSelect from '../../util/AccountSelect';

const voucherTypes = [
  { enum: 'IN', desc: 'Invoice' },
  { enum: 'DP', desc: 'Direct Payment' },
];

const OrgSettings = () => {
  const { orgStore, authStore, dataStore } = useRootStore();
  const { settings } = orgStore;
  const { ExtSysId } = settings;

  const moveAccountTypeToFront = (list, typeId) => {
    const index = list.findIndex(({ id }) => id === typeId);
    list.splice(0, 0, list.splice(index, 1)[0]);
    return list;
  };

  return (
    <Formik
      initialValues={{
        Name: settings.Name,
        VoucherTypeDefault: settings.VoucherTypeDefault,
        ExtSysPull: !!settings.ExtSysPull,
        ExtSysPush: !!settings.ExtSysPush,
        APAccountId: safeFalsy(settings.APAccountId, null),
        APAccountObject: dataStore.getAccountFromId(settings.APAccountId),
        ARAccountId: safeFalsy(settings.ARAccountId, null),
        ARAccountObject: dataStore.getAccountFromId(settings.ARAccountId),
        APBankAccountId: safeFalsy(settings.APBankAccountId, null),
        APBankAccountObject: dataStore.getAccountFromId(
          settings.APBankAccountId,
        ),
        ARBankAccountId: safeFalsy(settings.ARBankAccountId, null),
        ARBankAccountObject: dataStore.getAccountFromId(
          settings.ARBankAccountId,
        ),
      }}
      onSubmit={async (values, actions) => {
        try {
          const merge = { ...settings, ...values };
          const {
            Name,
            OrgStatusId,
            // ExtSysId,
            LegalName,
            CountryCode,
            CurrencyCode,
            TimeZone,
            FinancialCloseDate,
            VoucherTypeDefault,
            ExtSysPull,
            ExtSysPush,
            APAccountId,
            ARAccountId,
            APBankAccountId,
            ARBankAccountId,
          } = merge;
          await authStore.request.post(
            `${process.env.REACT_APP_API}/api/organization`,
            {
              organizationInfo: {
                Name,
                StatusId: OrgStatusId,
                ExtSysId,
                LegalName,
                CountryCode,
                CurrencyCode,
                TimeZone,
                FinancialCloseDate,
                VoucherTypeDefault,
                ExtSysPull,
                ExtSysPush,
                APAccountId,
                ARAccountId,
                APBankAccountId,
                ARBankAccountId,
              },
            },
          );
          await orgStore.retrieveConfig();
          actions.resetForm();
        } catch (e) {
          console.error(e);
        }
        actions.setSubmitting(false);
      }}
      render={({
        handleBlur,
        handleChange,
        errors,
        handleSubmit,
        values,
        isSubmitting,
        dirty,
        setFieldValue,
      }) => {
        const isValidBankAccountGroup = (TypeId, BankAccountType) => {
          return Boolean(BankAccountType);
        };
        return (
          <FlexDiv>
            <StandardBox showoverflow={1} style={{ marginBottom: '1rem' }}>
              <Typography variant="h4" gutterBottom>
                Settings
              </Typography>
              <StyledForm onSubmit={handleSubmit}>
                <TextField
                  name="Name"
                  label="Org Name"
                  value={values.Name}
                  margin="normal"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  variant="outlined"
                  inputProps={{ maxLength: 45 }}
                  fullWidth
                  error={errors.Name}
                />
                <FormRow>
                  <SimpleSelect
                    label="Voucher Type Default"
                    handleChange={handleChange}
                    value={values.VoucherTypeDefault}
                    name="VoucherTypeDefault"
                  >
                    {voucherTypes.map(type => (
                      <MenuItem key={type.enum} value={type.enum}>
                        {type.desc}
                      </MenuItem>
                    ))}
                  </SimpleSelect>
                </FormRow>
                <FormRow>
                  <RowItem>
                    <div style={{ width: '100%', zIndex: 1001 }}>
                      <AccountSelect
                        placeholder="Default AP Account"
                        prefillDisabled
                        value={values.APAccountObject}
                        isValidAccountGroup={TypeId => TypeId === 2}
                        sortFunction={list => {
                          return moveAccountTypeToFront(
                            moveAccountTypeToFront(list, 7),
                            2,
                          );
                        }}
                        onChange={val => {
                          setFieldValue('APAccountObject', val);
                          setFieldValue(
                            'APAccountId',
                            safeEval(() => val.AccountId),
                            null,
                          );
                        }}
                      />
                    </div>
                  </RowItem>
                </FormRow>
                <FormRow>
                  <RowItem>
                    <div style={{ width: '100%', zIndex: 1002 }}>
                      <AccountSelect
                        placeholder="Default AR Account"
                        prefillDisabled
                        value={values.ARAccountObject}
                        isValidAccountGroup={TypeId => TypeId === 1}
                        sortFunction={list => {
                          return moveAccountTypeToFront(
                            moveAccountTypeToFront(list, 6),
                            1,
                          );
                        }}
                        onChange={val => {
                          setFieldValue('ARAccountObject', val);

                          setFieldValue(
                            'ARAccountId',
                            safeEval(() => val.AccountId),
                            null,
                          );
                        }}
                      />
                    </div>
                  </RowItem>
                </FormRow>
                <FormRow>
                  <RowItem>
                    <div style={{ width: '100%', zIndex: 1003 }}>
                      <AccountSelect
                        placeholder="Default AP Bank Account"
                        prefillDisabled
                        value={values.APBankAccountObject}
                        isValidAccountGroup={isValidBankAccountGroup}
                        // sortFunction={list =>
                        //   values.Type === 'AR'
                        //     ? moveAccountTypeToFront(list, 6)
                        //     : list
                        // }
                        onChange={val => {
                          setFieldValue('APBankAccountObject', val);

                          setFieldValue(
                            'APBankAccountId',
                            safeEval(() => val.AccountId),
                            null,
                          );
                        }}
                      />
                    </div>
                  </RowItem>
                </FormRow>
                <FormRow>
                  <RowItem>
                    <div style={{ width: '100%', zIndex: 1004 }}>
                      <AccountSelect
                        placeholder="Default AR Bank Account"
                        prefillDisabled
                        value={values.ARBankAccountObject}
                        isValidAccountGroup={isValidBankAccountGroup}
                        // sortFunction={list =>
                        //   values.Type === 'AR'
                        //     ? moveAccountTypeToFront(list, 6)
                        //     : list
                        // }
                        onChange={val => {
                          setFieldValue('ARBankAccountObject', val);

                          setFieldValue(
                            'ARBankAccountId',
                            safeEval(() => val.AccountId),
                            null,
                          );
                        }}
                      />
                    </div>
                  </RowItem>
                </FormRow>

                <Button
                  color="primary"
                  variant="contained"
                  type="submit"
                  size="large"
                  disabled={isSubmitting || !dirty}
                  style={{ marginTop: '1.2rem' }}
                >
                  Submit
                </Button>
              </StyledForm>
            </StandardBox>
          </FlexDiv>
        );
      }}
    />
  );
};

export default OrgSettings;
